<template>
   <div class="commission-definitions">
      <template v-if="mode === 'list'">
         <h1>{{ $t("commission_pageTitle") }}</h1>
         <table v-if="rules.length > 0">
            <thead>
               <tr>
                  <th>{{ $t("commission_thTripType") }}</th>
                  <th>{{ $t("commission_thCountryType") }}</th>
                  <th>{{ $t("commission_thCabinType") }}</th>
                  <th>{{ $t("commission_thPaxType") }}</th>
                  <th>{{ $t("commission_thAmountType") }}</th>
                  <th>{{ $t("commission_thAmount") }}</th>
                  <th></th>
               </tr>
            </thead>
            <tbody>
               <tr v-for="(item, index) in rules" :class="index % 2 == 0 ? 'even' : 'odd'" :data-id="item.id" :key="`row-${item.id}-${index}`">
                  <td class="multi-line">
                     <div v-for="(val, i) in item.tripTypes" :key="`trip-${item.id}-${i}`">
                        {{ $options.filters.EFltTripType(val) }}
                     </div>
                  </td>
                  <td class="multi-line">
                     <div v-for="(val, i) in item.countryTypes" :key="`country-${item.id}-${i}`">
                        {{ $options.filters.EFltCountryType(val) }}
                     </div>
                  </td>
                  <td class="multi-line">
                     <div v-for="(val, i) in item.cabinTypes" :key="`cabin-${item.id}-${i}`">
                        {{ $options.filters.EFltCabinType(val) }}
                     </div>
                  </td>
                  <td class="multi-line">
                     <div v-for="(val, i) in item.paxTypes" :key="`pax-${item.id}-${i}`">
                        {{ $options.filters.EFltPaxType(val) }}
                     </div>
                  </td>
                  <td>
                     <span>{{ $options.filters.EFltCommissionAmountType(item.amountType) }}</span>
                  </td>
                  <td>
                     {{ item.amount | price(item.currency) }}
                  </td>
                  <td>
                     <button class="remove-btn" @click="deleteCommission(item)">
                        <i class="gts-icon icon-sm icon-close-rounded"></i>
                     </button>
                  </td>
               </tr>
            </tbody>
         </table>
         <div class="actions">
            <UIButton v-if="rules.length < max" className="gray" :text="$t('commissionDefinition_addNewCommission')" @click.native="addCommission" />

            <p class="info" v-if="rules.length > 0">
               {{ handlerCommissionFmts("max") }}<br />
               {{ handlerCommissionFmts("defined") }}<br />
            </p>
         </div>
      </template>
      <template v-else-if="mode === 'add'">
         <h1>{{ $t("commission_pageAddTitle") }}</h1>
         <div class="commission-form">
            <div class="form-row">
               <div class="form-col">
                  <label>{{ $t("commissionDefinition_lblTripTypes") }}</label>
                  <UIMultiSelect :key="$i18n.locale" :options="tripTypeList" v-model="commissionSetRequest.tripTypes" lighter allow-search />
               </div>
               <div class="form-col">
                  <label>{{ $t("commissionDefinition_lblCountryTypes") }}</label>
                  <UIMultiSelect :key="$i18n.locale" :options="countryTypeList" v-model="commissionSetRequest.countryTypes" lighter allow-search />
               </div>
               <div class="form-col">
                  <label>{{ $t("commissionDefinition_lblCabinTypes") }}</label>
                  <UIMultiSelect :key="$i18n.locale" :options="cabinTypeList" v-model="commissionSetRequest.cabinTypes" lighter allow-search />
               </div>
               <div class="form-col">
                  <label>{{ $t("commissionDefinition_lblPaxTypes") }}</label>
                  <UIMultiSelect :key="$i18n.locale" :options="paxTypeList" v-model="commissionSetRequest.paxTypes" lighter />
               </div>
               <div class="form-col">
                  <label>{{ $t("commissionDefinition_lblAmountType") }}</label>
                  <UISelectBox :key="$i18n.locale" :options="commissionAmountTypeList" v-model="commissionSetRequest.amountType" lighter />
               </div>
               <div class="form-col">
                  <label>{{ $t("commissionDefinition_lblAmount") }}</label>
                  <UIInput
                     :key="$i18n.locale"
                     type="number"
                     v-model="commissionSetRequest.amount"
                     v-input="{ type: 'decimal', required: true, requiredMsg: $t('common_cannotBeEmpty'), range: ['0,01', '199,99'] }"
                     lighter />
               </div>
               <div class="form-col">
                  <label>{{ $t("commissionDefinition_lblCurrency") }}</label>
                  <UISelectBox :key="$i18n.locale" :options="currencyList" v-model="commissionSetRequest.currency" lighter />
               </div>
            </div>
            <div class="form-actions">
               <UIButton className="gray" :text="$t('commission_cancel')" @click.native="cancelCommission" />
               <UIButton className="default" :text="$t('commission_save')" @click.native="saveCommission" />
            </div>
         </div>
      </template>
   </div>
</template>

<script>
import { settingsService } from "@/service";
import UIButton from "@/components/unitary/Button.vue";
import UIInput from "@/components/unitary/form2/UIInput.vue";
import UISelectBox from "@/components/unitary/form2/UISelectBox.vue";
import UIMultiSelect from "@/components/unitary/form2/UIMultiSelect.vue";
import Popup from "@/gts-popup.js";

export default {
   name: "CommissionDefinition",
   components: {
      UIInput,
      UIButton,
      UISelectBox,
      UIMultiSelect,
   },
   data() {
      return {
         max: 10,
         mode: "list",
         commissionListRequest: {
            status: 1,
         },
         initialCommissionSetRequest: {
            id: 0,
            status: 1,
            dbState: null,
            tripTypes: [1, 2, 3],
            countryTypes: [1, 2],
            cabinTypes: [1, 2],
            paxTypes: [1, 2, 3],
            amountType: 1,
            amount: "0",
            currency: "EUR",
         },
         commissionSetRequest: {
            id: 0,
            status: 1,
            dbState: null,
            tripTypes: [1, 2, 3],
            countryTypes: [1, 2],
            cabinTypes: [1, 2],
            paxTypes: [1, 2, 3],
            amountType: 1,
            amount: "0",
            currency: "EUR",
         },
         rules: [],
      };
   },
   created() {
      this.listFlightCommissionRules();
   },
   computed: {
      tripTypeList() {
         return this.$GtsDropdownData.EFltTripType();
      },
      countryTypeList() {
         return this.$GtsDropdownData.EFltCountryType();
      },
      cabinTypeList() {
         return this.$GtsDropdownData.EFltCabinType();
      },
      paxTypeList() {
         return this.$GtsDropdownData.EFltPaxType(false, false, [4, 5, 6]);
      },
      commissionAmountTypeList() {
         return this.$GtsDropdownData.EFltCommissionAmountType(false, false, [2]);
      },
      currencyList() {
         return [{ value: "EUR", name: this.$t("EComCurrency_EUR") }];
      },
   },
   methods: {
      addCommission() {
         this.commissionSetRequest = { ...this.initialCommissionSetRequest };
         this.mode = "add";
      },
      deleteCommission(item) {
         Popup.confirm(this.$t("commissionDefinition_confirmDelete"), this.$t("commissionDefinition_deleteCommission"), null).then((result) => {
            if (result.success) {
               this.commissionSetRequest = item;
               this.commissionSetRequest.dbState = 3;
               settingsService
                  .setFlightCommissionRule(this.commissionSetRequest)
                  .then((res) => {
                     if (res.result.success) {
                        Popup.info(this.$t("commissionDefinition_commissionDeleted"), this.$t("commissionDefinition_commissionSuccessfullyDeleted"));
                        this.listFlightCommissionRules();
                     }
                  })
                  .catch((error) => {
                     console.error("Error flight commission rule set:", error);
                  });
            }
         });
      },
      saveCommission() {
         this.$validate().then((res) => {
            if (res.success) {
               Popup.confirm(this.$t("commissionDefinition_confirmSave"), this.$t("commissionDefinition_saveCommission"), null).then((result) => {
                  if (result.success) {
                     this.commissionSetRequest.dbState = 1;
                     this.commissionSetRequest.amount = this.commissionSetRequest.amount.toString().replace(",", ".");
                     settingsService
                        .setFlightCommissionRule(this.commissionSetRequest)
                        .then((res) => {
                           if (res.id == -104) {
                              Popup.warning(this.$t("commissionDefinition_error"), this.$t("commissionDefinition_errorDublicateCommission"));
                           } else if (res.result.success) {
                              Popup.info(this.$t("commissionDefinition_commissionSaved"), this.$t("commissionDefinition_commissionSuccessfullySaved"));
                           }
                           this.mode = "list";
                           this.listFlightCommissionRules();
                        })
                        .catch((error) => {
                           console.error("Error flight commission rule set:", error);
                        });
                  }
               });
            }
         });
      },
      cancelCommission() {
         this.mode = "list";
      },
      listFlightCommissionRules() {
         this.$store.commit("app/setIsProgressGifActive", true);
         settingsService
            .listFlightCommissionRules(this.commissionListRequest)
            .then((res) => {
               this.rules = res.rules;
               this.$store.commit("app/setIsProgressGifActive", false);
            })
            .catch((error) => {
               console.error("Error flight commission rule list:", error);
            });
      },
      handlerCommissionFmts(type) {
         switch (type) {
            case "max":
               return this.$t("commissionDefinition_maxCommissionInfo").replace("#VALUE#", this.max);
            case "defined":
               return this.$t("commissionDefinition_definedCommissionCount").replace("#VALUE#", this.rules.length);
            default:
               return "";
         }
      },
   },
};
</script>

<style lang="scss" scoped>
.commission-definitions {
   max-width: 900px;
   margin: 2rem auto;
   padding: 0 1rem;
   overflow-x: auto;

   h1 {
      font-size: 1.5rem;
      font-weight: 600;
      margin-bottom: 1.25rem;
      line-height: 1.2;

      @media (max-width: 1200px) {
         font-size: 1.4rem;
      }
      @media (max-width: 576px) {
         font-size: 1.25rem;
      }
   }

   table {
      width: 100%;
      border-collapse: separate;
      border-spacing: 0 10px;
      margin-bottom: 1rem;
      min-width: 780px;

      @media (max-width: 992px) {
         min-width: 720px;
      }
      @media (max-width: 768px) {
         min-width: 680px;
         border-spacing: 0 8px;
      }
      @media (max-width: 576px) {
         min-width: 640px;
      }
      @media (max-width: 400px) {
         min-width: 600px;
      }

      thead {
         th {
            white-space: nowrap;
            text-align: left;
            padding: 0.75rem 1rem;
            font-weight: 600;
            color: var(--gray-700);
            border-bottom: 1px solid var(--gray-300);
            font-size: 0.95rem;

            @media (max-width: 1200px) {
               padding: 0.6rem 0.75rem;
               font-size: 0.9rem;
            }
            @media (max-width: 992px) {
               font-size: 0.875rem;
            }
            @media (max-width: 768px) {
               padding: 0.5rem 0.6rem;
               font-size: 0.85rem;
            }
            @media (max-width: 576px) {
               font-size: 0.8rem;
            }
         }
      }

      tbody {
         tr {
            height: 44px;
            overflow: hidden;
            white-space: nowrap;

            &.even {
               background: var(--blue-100);
            }
            &.odd {
               background: var(--gray-50);
            }

            @media (max-width: 768px) {
               height: 40px;
            }
            @media (max-width: 576px) {
               height: 38px;
            }

            td:first-child {
               border-top-left-radius: 50px;
               border-bottom-left-radius: 50px;

               @media (max-width: 576px) {
                  border-top-left-radius: 20px;
                  border-bottom-left-radius: 20px;
               }
            }

            td:last-child {
               border-top-right-radius: 50px;
               border-bottom-right-radius: 50px;

               @media (max-width: 576px) {
                  border-top-right-radius: 20px;
                  border-bottom-right-radius: 20px;
               }
            }

            td {
               padding: 0.75rem 1rem;
               vertical-align: middle;
               font-size: 0.95rem;

               @media (max-width: 1200px) {
                  padding: 0.6rem 0.75rem;
                  font-size: 0.9rem;
               }
               @media (max-width: 992px) {
                  font-size: 0.875rem;
               }
               @media (max-width: 768px) {
                  padding: 0.5rem 0.6rem;
                  font-size: 0.85rem;
               }
               @media (max-width: 576px) {
                  font-size: 0.8rem;
               }

               > div {
                  display: inline-flex;
                  align-items: center;
                  padding: 2px 8px;
                  margin: 2px 6px 2px 0;
                  border-radius: 9999px;
                  background: var(--gray-700-alpha-90);
                  line-height: 1.2;
                  white-space: nowrap;

                  @media (max-width: 992px) {
                     margin: 2px 4px 2px 0;
                     padding: 2px 6px;
                     font-size: 0.85em;
                  }
                  @media (max-width: 576px) {
                     padding: 2px 6px;
                     margin-right: 4px;
                  }
               }

               &.multi-line > div {
                  display: block;
                  margin: 2px 0;
               }

               &:last-child {
                  text-align: center;
               }
            }
         }
      }
   }

   .actions {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .info {
         color: var(--gray-500);
         font-size: 0.875rem;
         line-height: 1.35;
         margin-top: 0.5rem;
         text-align: center;

         @media (max-width: 576px) {
            font-size: 0.8rem;
         }
      }
   }

   .icon-close-rounded {
      filter: brightness(0) saturate(100%) invert(23%) sepia(97%) saturate(7492%) hue-rotate(353deg) brightness(97%) contrast(119%);

      @media (max-width: 576px) {
         transform: scale(1.1);
      }
   }

   @media (max-width: 768px) {
      margin: 1rem auto;
      padding: 0 0.5rem;
   }
}

.commission-form {
   .form-row {
      display: flex;
      flex-direction: column;
      gap: 1rem;

      @media (max-width: 768px) {
         gap: 0.85rem;
      }
      @media (max-width: 576px) {
         gap: 0.75rem;
      }

      .form-col {
         width: 100%;
         display: grid;
         grid-template-columns: 400px 1fr;
         align-items: center;
         gap: 0.5rem;
         margin-left: 0;
         margin-right: 0;

         @media (max-width: 1200px) {
            grid-template-columns: 320px 1fr;
         }
         @media (max-width: 992px) {
            grid-template-columns: 260px 1fr;
         }
         @media (max-width: 768px) {
            grid-template-columns: 1fr;
            gap: 0.35rem;
         }

         label {
            margin-bottom: 0;
            font-weight: 500;
            text-align: left;
            padding-right: 0.5rem;
            grid-column: 1;
            font-size: 0.95rem;

            @media (max-width: 768px) {
               grid-column: auto;
               padding-right: 0;
               font-size: 0.9rem;
            }
         }
      }
   }

   .form-actions {
      margin-top: 1rem;
      display: flex;
      gap: 0.75rem;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;

      @media (max-width: 768px) {
         justify-content: stretch;

         button,
         .UIButton {
            width: 100%;
         }
      }
   }
}
</style>
